import { FeatureCollection } from "./types";

export const getGeoJSONWrapperForFeatureCollection = (attribution: string, featureCollection: FeatureCollection) => ({
    'type': 'geojson',
    'attribution': attribution,
    'data': featureCollection,
});

export const emptyGeoJSON = (attribution: string) => ({
    'type': 'geojson',
    'attribution': attribution,
    'data': emptyFeatColl()
});

export const emptyFeatColl = () => ({
    'type': 'FeatureCollection',
    'features': []
});